import { render, staticRenderFns } from "./UnitModal.vue?vue&type=template&id=e1483d8c&"
import script from "./UnitModal.vue?vue&type=script&lang=ts&"
export * from "./UnitModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports